import { wrap as withStyle } from 'utils/styles'

export default withStyle(({ theme }) => {
  const { badgeBorderColor } = theme
  return `
    width: 16px;
    box-shadow: 0 0 0 1px ${badgeBorderColor};
    padding: 0 !important; //ie11 fix
  `
})
